import {defineStore} from "pinia";

export type Device =  'pc' | 'mobile';
export type Os = 'window' | 'ios' | 'macintosh' | 'android';
export type Browser =  'edge' | 'chrome' | 'opera' | 'firefox' | 'safari'
export type DeviceInfoState = {
  device: Device,
  os: Os,
  browser: Browser
}

export const useDeviceInfoStore = defineStore('deviceInfo', {
  //디폴트값 be에서내려주낭? FE에서 agent체크하나?
  state: (): DeviceInfoState => ({
      device: 'pc',
      os: 'window',
      browser: 'chrome'
    }

  ),
  getters: {


  },
  actions: {
    //device변경 : 클라이언트 resize체크 or admin 상태변경
    //os? browser?
    setDevice(payload: Device){
     // Object.assign(this, payload);
      this.device = payload;
    },
  },

});
